import React, { useEffect, useState } from 'react';

import { Carousel } from '../../components/common/Carousel';
import ModelActions from './ModelActions';
import ModelViewer from './ModelViewer';
import FSNList from './FSNList';

import { getProductsforAllFSNs } from '../../utils/api/requestApi';

import { DISPLAY_TEXT, VISUALIZE_PRODUCTS_SUBHEADING } from '../../utils/constants/text';

import { ProductImage } from '../../types/product';

import { Next } from '../../icons';

import { useCommonStore } from '../../stores/commonStore';

const Heading = ({ activeProduct }) => {
    return (
        <div className="pb-1">
            <div className="flex items-center mb-2">
                <div className="text-xl font-semibold text-black mr-4 flex items-center">
                    Visualise Product {activeProduct}
                    <Next />
                </div>
            </div>
            <div className="text-gray-500 whitespace-no-wrap text-base">{VISUALIZE_PRODUCTS_SUBHEADING} </div>
        </div>
    );
};

const Sandbox = () => {
    const fsns = useCommonStore((state) => state.threeDLiveFsns);
    const activeProduct = useCommonStore((state) => state.activeFSN);
    const setToastMessage = useCommonStore((state) => state.setToastMessage);

    const [productsData, setProductsData] = useState<any>(null);
    const [thumbnails, setThumbnails] = useState<Array<ProductImage> | null>(null);

    const isFsnsFailed = fsns?.every((item) => !item.status);

    const getProducts = async () => {
        try {
            const products = fsns?.map((product) => product.fsn);
            const responseFromZulu = await getProductsforAllFSNs(products);
            setProductsData(responseFromZulu.data);

            let newThumbnails = responseFromZulu.data.productCards.filter((p) => p.fsn === activeProduct)?.[0]?.productImages;
            newThumbnails = newThumbnails ?? [];
            setThumbnails(newThumbnails);
        } catch (error) {
            setToastMessage({ type: 'error', message: 'Something went wrong in fetching images' });
            console.log('Error in fetching requests:', error);
        }
    };

    useEffect(() => {
        getProducts();
    }, [activeProduct]);

    useEffect(() => {
        let newThumbnails = productsData?.productCards?.filter((p) => p.fsn === activeProduct)[0]?.productImages;
        newThumbnails = newThumbnails ?? [];
        if (productsData) setThumbnails(newThumbnails);
    }, [activeProduct, productsData]);

    return (
        <div className=" h-screen flex flex-row w-full">
            <FSNList fsns={fsns} showDownloadCSV={true} showVisualQC={true} />

            {isFsnsFailed ? (
                <div className="flex justify-center items-center h-full w-full">{DISPLAY_TEXT.ALL_FSN_FAILED_ON_GUARDRAILS}</div>
            ) : (
                <>
                    <div className=" flex flex-col w-full h-full overflow-hidden">
                        {/* <Heading activeProduct={activeProduct} /> */}
                        <div className="flex  flex-row  w-full" style={{ height: 'calc(100vh - 108px - 64px )' }}>
                            <div style={{ width: '60%' }}>
                                <ModelViewer fsns={fsns} />
                            </div>

                            <div style={{ width: '40%' }}>
                                <Carousel thumbnails={thumbnails} />
                            </div>
                        </div>
                        <ModelActions />
                    </div>
                </>
            )}
        </div>
    );
};

export default React.memo(Sandbox);
